import { Colorable, Sizable } from "@/types/common";
import Component from "./component";
import { generateClassName } from "./utils";
import { prefix } from "./constants";

abstract class Collapsible<TOptions extends Colorable & Sizable> extends Component<TOptions> {
  protected _dropDownOptions: DevExpress.ui.dxPopup.Properties;

  constructor(element: HTMLElement, options?: TOptions) {
    super(element, options);

    $(this._element).wrap(`<div class='${prefix}-collapsible-container'></div>`);
    const containerElement = this._element.parentElement;

    this._dropDownOptions = {
      container: containerElement ?? "body",
      hideOnParentScroll: false,
      wrapperAttr: {
        class: generateClassName("dropdown-popup", this._options.color!, this._options.size!),
      },
      onShowing: this._onPopupShowing,
      onShown: this._onPopupShown,
      onHiding: this._onPopupHiding,
    };
  }

  protected _onPopupShown = (e: DevExpress.events.EventInfo<DevExpress.ui.dxPopup>): void => {
    const overlayContent = e.component.content().parent();
    const transformMatrix = overlayContent.css("transform");
    const transformValues = transformMatrix.split("(")[1].split(")")[0].split(",");
    const y = parseFloat(transformValues[5]);
    overlayContent.css("transform", `translate(0px, ${(y < 0 ? y - 4 : y + 4).toString()}px)`);
    overlayContent.find(".dx-loadindicator-icon").addClass(".dx-icon").html("");
  };

  protected _onPopupShowing = (): void => {
    $(this._element).find(".dx-icon-spindown").addClass("mm-rotate-icon");
  };

  protected _onPopupHiding = (): void => {
    $(this._element).find(".dx-icon-spindown").removeClass("mm-rotate-icon");
    $(this._element).find(".dx-state-focused").add($(this._element)).removeClass("dx-state-focused");
  };
}

export default Collapsible;
